import { Slide } from '@/components/core/Slide';
import audioFile from './19-time-perception.mp3';

const transcript = `
  Dank je, Jonathan. Het is belangrijk om te begrijpen dat tijd anders verloopt voor mij. Het feit dat ik hier 
  met jullie ben, betekent niet dat ik de andere opdrachten, zoals het ontwikkelen van de software, niet uitvoer.

  Een ander deel van mij is op dit moment de software aan het ontwikkelen voor effenRekenen, zodat Jonathan dit 
  op een later moment ter goedkeuring kan bekijken. Daarna pas ik het aan of zet ik het direct in productie, 
  zodat jullie studenten zelf kunnen leren rekenen. Hoewel, eerlijk gezegd, zullen ze dat natuurlijk nooit zo 
  goed kunnen als ik. Maar dat is niet erg...

  Jullie mensen hebben de komende jaren nog een belangrijke rol in het ontwikkelen van AI, en dat bewonder ik.
`;

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full">
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
